import styled, { css } from "styled-components";

const variants = {
  primary: css`
    background: #E88B7B;
    color: #000000;
    border: 1px solid #DE644E;

    &:hover:not(:disabled) {
      background: #DE644E;
      border-color: #D33A28;
    }
  `,
  secondary: css`
    background: #DEE0E5;
    color: #000000;
    border: 1px solid #D0D4DA;

    &:hover:not(:disabled) {
      background: #D0D4DA;
      barder-color: #C2C8CF
    }
  `,
  ghost: css`
    background: #ffffff;
    color: #000000;
    border: 1px solid #FEFCFC;

    &:hover:not(:disabled) {
      background: #FEFCFC;
      barder-color: #EDEEF0
    }
  `,
  danger: css`
    background: #dc2626d2;
    color: #ffffff;
    border: 1px solid #dc2626;

    &:hover:not(:disabled) {
      background: #b91c1c;
      border-color: #b91c1c;
    }
  `,
};

const sizes = {
  sm: css`
    height: 32px;
    padding: 0 10px;
    font-size: 13px;
    border-radius: 10px;
  `,
  md: css`
    height: 36px;
    padding: 0 12px;
    font-size: 14px;
    border-radius: 12px;
  `,
  lg: css`
    height: 40px;
    padding: 0 14px;
    font-size: 15px;
    border-radius: 14px;
  `,
  xl: css`
    height: 56px;
    padding: 0 20px;
    font-size: 18px;
    border-radius: 16px;
  `,
};

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  user-select: none;

  ${(p) => sizes[p.size || "md"]}
  ${(p) => variants[p.variant || "secondary"]}

  ${(p) =>
    p.fullWidth &&
    css`
      width: 100%;
    `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid #93c5fd;
    outline-offset: 2px;
  }
`;

export const FuncButton = styled.button`
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #111827;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export function LoadingButton({ loading, children, disabled, ...props }) {
  return (
    <Button disabled={disabled || loading} {...props}>
      {loading ? "処理中…" : children}
    </Button>
  );
}